export default __webpack_public_path__ + "static/media/business.d0b4bf03.svg";